@if (isDefined()) {
<app-header [nav]="nav" />
} @if (isDefined()) { @if (isDefined()) {
<h2 class="header">Recommendation: {{ recommendations.recommendationTitle || recommendations.auditDefinition }}</h2>
} @if (isEditMode()) {
<button
  mat-raised-button
  (click)="sendRecommendation()"
  [disabled]="isSaving">
  @if (isSaving) {
  <mat-spinner
    diameter="20"
    class="button-spinner"></mat-spinner>
  <span>Saving...</span>
  } @else { Save }
</button>
}
<button
  mat-raised-button
  (click)="openDialog()"
  class="mat-raised-button edit">
  Close
</button>
<app-invalid-form-summary
  [errorText]="error"
  [invalidFields]="invalidFields"
  (fieldSelected)="goToInvalidField($event)" />
@if(form){
<mat-tab-group
  [selectedIndex]="currentTab"
  (selectedIndexChange)="updateTabs($event)"
  [formGroup]="form">
  <!-- Assessor's Processing -->
  <mat-tab label="Auditee's Processing">
    @if (!isSaving && recommendations) {
    <app-recommendation-assessors-processing
      [form]="form"
      [recommendations]="recommendations"
      [assessmentEditable]="assessmentEditable"
      [auditorEditable]="auditorEditable" />
    }
  </mat-tab>
  <!-- Auditor's Processing -->
  <mat-tab label="Auditor's Processing">
    @if (!isSaving) {
    <app-recommendation-auditors-processing
      [recommendations]="recommendations"
      [form]="form"
      [auditorEditable]="auditorEditable"
      (putToPending)="putBackToPending()"
      (finallySettle)="finallySettleRecommendation()" />
    }
  </mat-tab>
  <!-- Basic definitions -->
  <mat-tab label="Basic definitions">
    <app-recommendations-basic-definitions
      [recommendations]="recommendations"
      [form]="form" />
  </mat-tab>
  <!-- Files -->
  <mat-tab label="Files">
    <app-file-upload
      [form]="form"
      [onlyDownload]="isEditMode()"
      [fileLinkId]="fileLinkId" />
  </mat-tab>
  <!-- Logs -->
  <mat-tab label="Logs">
    <app-recommendation-logs [recommendations]="recommendations" />
  </mat-tab>
  <!-- Hidden fields -->
  @if (auditorEditable) {
  <mat-tab label="Hidden fields">
    <app-recommendation-hidden-fields
      [recommendations]="recommendations"
      [form]="form" />
  </mat-tab>
  }
</mat-tab-group>
} } @else {
<h1>Loading...</h1>
} @if (!isDefined()) {
<mat-spinner class="spinner" />
}
